import { createContext } from "react";
export default createContext({
    userAccountIds: [""],
    userRole: "",
    userId: "",
    userEmail: "",
    replyStatus: 200,
});
//# sourceMappingURL=UserContext.js.map